import { IS_NA, IS_US } from "helpers/application"
import useWindowDimensions from "helpers/window-dimensions"

export const usePopupTrigger = () => {
  const { isMobile } = useWindowDimensions()

  return () => {
    try {
      if (IS_NA()) {
        const attentiveBoxID = isMobile
          ? IS_US()
            ? 1306983 // US Mobile
            : 1311719 // CA Mobile
          : IS_US()
            ? 1306982 // US Desktop
            : 1311567 // CA Desktop
        window.__attentive.trigger(null, null, null, attentiveBoxID)
        // } else if (IS_INT()) {
        //   const globaleBoxID = "aee6786c-941d-4447-a7e9-74364ff13e18" // global e 321134
        //   window.DIGIOH_API.LIGHTBOX.loadLightbox(globaleBoxID)
      } else {
        const lightboxID = "acb91908-2c05-44ab-a719-47b5633fff8e" // 325686
        console.log("Popup trigger", lightboxID)
        window.DIGIOH_API.LIGHTBOX.loadLightbox(lightboxID)
      }
    } catch (err) {
      console.log("Error loading popup: ", err)
    }
  }
}

export default usePopupTrigger
